import axios from 'axios';
import { useState } from 'react'
import { BASE_URL } from '../constants/urls';

const useCouponRedirect = () => {

    const [loadingLink, setLoadingLink] = useState(false);
    const [errorLink, setErrorLink] = useState(null);

    const getcouponRedirect = async (data) => {
        setLoadingLink(true);
        setErrorLink(null);

        try {
            const res = await axios.post(`${BASE_URL}/coupon/redirect`, data, {
                headers: {Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`}
            })

            const tracked = res.data; // adapte conforme estrutura da resposta
            
            return tracked;

        } catch (err) {
        setErrorLink(err?.response?.data?.message || err.message || 'Erro ao gerar link');
        } finally {
        setLoadingLink(false);
        }
    }

  return { getcouponRedirect, loadingLink, errorLink }
}

export default useCouponRedirect